// 组件对象，大写
import crudEdit from './crudEdit.vue'
export default crudEdit
